
import React, { ReactNode, useState } from 'react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';

type MainLayoutProps = {
  children: ReactNode;
  defaultCollapsed?: boolean;
};

const MainLayout: React.FC<MainLayoutProps> = ({ children, defaultCollapsed = false }) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  return (
    <div className="min-h-screen flex flex-col">
      <Topbar onToggleSidebar={() => setIsCollapsed(prev => !prev)} />
      <div className="flex flex-1">
        <Sidebar isCollapsed={isCollapsed} />
        <main className="flex-1 overflow-auto bg-gray-50 p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
